import { render, staticRenderFns } from "./RankTitle.vue?vue&type=template&id=64062d8e&"
import script from "./RankTitle.vue?vue&type=script&lang=js&"
export * from "./RankTitle.vue?vue&type=script&lang=js&"
import style0 from "./RankTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports